import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import queryString from 'query-string';
import api from '../../../helpers/api';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifySuccess, notifyError, notifyShow} from '../../../common/redux/notificationReducer';
import {ContentLoader} from '../../../common/components/loader';
import stationOperatorCreateAlertForm from '../locales/stationOperatorCreateAlertForm.json';
import Modal from "react-bootstrap-modal";
import {Error, Input} from "../../../common/components/form";
import Validator from "validatorjs";

class StationOperatorCreateAlertForm extends Component {
	constructor(props) {
		super(props);

		const {loadLanguage} = props;
		loadLanguage(stationOperatorCreateAlertForm);

		this.state = {
			isLoading: true,
			stations: [],
			selectedStation: {},
			selectedStationAlerts: [],
			showModal: false,
			showPasswordModal: false,
			errors: {},
			passwordForm: {
				password: ''
			}
		}
	}

	componentDidMount() {
		this.loadForm();
	}

	loadForm = async () => {
		const {notifyError} = this.props;
		try {
			const response = await api.get('/alert/create-station-operator');

			const stations = response.data.stations;

			let selectedStation = {};
			let selectedStationAlerts = [];
			if(stations.length) {
				selectedStation = stations[0];
				selectedStationAlerts = stations[0].station_alerts;
			}

			this.setState({
			    isLoading: false,
				stations: stations,
				selectedStation: selectedStation,
				selectedStationAlerts: selectedStationAlerts
            });
		} catch (error) {
			notifyError(error.message);
		}
	};

	alertButtonClicked = async (alertId, e) => {
		const {notifyError, notifyShow} = this.props;
		try {
			const {selectedStationAlerts} = this.state;
			const selectedStationAlert = selectedStationAlerts.find(item => item.id === alertId);
			const values = {
				station_alert_id: selectedStationAlert.id,
				station_id: selectedStationAlert.station_id
			};
			await api.post('/alert/create-station-operator', values);
			notifyShow({
				title: 'Alert Created',
				message: 'Your Supervisor has been notified',
				position: 'tc',
				autoDismiss: 5
			}, 'error');
		} catch (error) {
			notifyError(error.message);
		}
	};

	openModal = () => this.setState({ showModal: true });
	closeModal = () => this.setState({ showModal: false });

	openPasswordModal = () => this.setState({ showPasswordModal: true });
	closePasswordModal = () => this.setState({ showPasswordModal: false, passwordForm: {password: ''}, errors: {}});

	updateState = (object) => {
		this.setState({
			passwordForm: {
				...this.state.passwordForm,
				...object
			}
		})
	};

	formSubmit = async (e) => {
		e.preventDefault();
		const {passwordForm} = this.state;

		let validation = new Validator(passwordForm, {'password': 'required'}, {"required.password": "Password is required"});
		if(validation.fails()) {
			return this.setState({errors: validation.errors.all()});
		}

		try {
			await api.post('/auth/validate-password', passwordForm);
			this.closePasswordModal();
			this.openModal();
		} catch (error) {
			this.setState({errors: {
				password: [error.message]
			}});
		}
	};

	switchStation = (e) => {
		this.openPasswordModal();
	};

	stationButtonClicked = (stationId, e) => {
		const {stations} = this.state;
		const selectedStation = stations.find(item => item.id === stationId);
		const selectedStationAlerts = selectedStation.station_alerts;
		this.setState({
			showModal: false,
			selectedStation: selectedStation,
			selectedStationAlerts: selectedStationAlerts
		});
	};

	openFullScreen = (e) => {
		window.open('/station-operator-alerts?fullscreen=1', '', 'fullscreen=yes, scrollbars=auto');
	};

	render() {
		const {translate, location} = this.props;
		const {isLoading, stations, selectedStationAlerts, showModal, showPasswordModal, passwordForm, errors} = this.state;

		let isFullScreen = false;
		if(location.search) {
			const getParams = queryString.parse(location.search);
			if(getParams.fullscreen === '1') {
				isFullScreen = true;
			}
		}

		const content = (
			<div className="content-wrapper">
				<div className="container">
					<section className="content">
						<div className="row text-center pad">
							<div className="col-md-12">
								<h1><strong>Please point out the issue</strong></h1>
							</div>
						</div>
						<div className="row text-center">
							{
								selectedStationAlerts.map((item, index) => (
									<div className="col-lg-3 col-md-3 col-sm-4 col-xs-6 pad" key={`alert-form-${index}`}>
										<button type="button" className="btn" onClick={e => this.alertButtonClicked(item.id, e)}>
											<div className="img-container">
												<img width="100%" className="img-rounded" src={item.icon_url} alt=""/>
											</div>
											<h4>{item.name}</h4>
										</button>
									</div>
								))
							}
						</div>
						<div className="row text-center pad">
							<div className="col-md-12">
								{
									stations.length > 1 && (
										<button type="button" className="btn btn-warning btn-inverse" onClick={this.switchStation}>
											Switch Station
										</button>
									)
								}
								{
									!isFullScreen && (
										<button type="button" className="btn btn-warning btn-inverse" onClick={this.openFullScreen}>
											Make Full Screen
										</button>
									)
								}
							</div>
						</div>
					</section>
				</div>

				<Modal dialogClassName='modal-md' show={showModal} onHide={this.closeModal} >
					<Modal.Header closeButton>
						<Modal.Title id='StationModalHeader'>Stations</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{
							stations.map((item, index) => (
								<button key={`alert-form-stations-${index}`}
										type="button"
										className="btn-lg btn-flat btn-info btn-block"
										onClick={e => this.stationButtonClicked(item.id, e)}
								>
									{item.name}
								</button>
							))
						}
					</Modal.Body>
				</Modal>

				<Modal dialogClassName='modal-sm' show={showPasswordModal} onHide={this.closePasswordModal} >
					<Modal.Header closeButton>
						<Modal.Title id='PasswordModalHeader'>Password</Modal.Title>
					</Modal.Header>
					<form onSubmit={this.formSubmit}>
						<Modal.Body>
							<div className="form-group">
								<Input type="password" value={passwordForm.password} autoComplete="off" onChange={e => this.updateState({password: e.target.value})} />
								{errors.password && <Error text={errors.password[0]} />}
							</div>
						</Modal.Body>
						<Modal.Footer>
							<button type="submit" className="btn btn-primary">Submit</button>
						</Modal.Footer>
					</form>
				</Modal>
			</div>
		);
		return translate('station_manager_alert_form_page_title_create') && !isLoading ? content : <ContentLoader/>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale)
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifySuccess,
	notifyError,
	notifyShow
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StationOperatorCreateAlertForm);
